import {
  FileuploadPickerContext,
  FileuploadPickerContextValues as FileuploadPickerContextValue,
} from './FileuploadPickerContext'

export const FileuploadPickerProvider: React.FC<{
  value: FileuploadPickerContextValue
  children: React.ReactNode
}> = ({ value, children }) => {
  return (
    <FileuploadPickerContext.Provider value={value}>
      {children}
    </FileuploadPickerContext.Provider>
  )
}

FileuploadPickerProvider.displayName = 'FileuploadPickerProvider'
